import { Outlet } from 'react-router';

export function SourcingPage() {
  return <Outlet />;
}
